/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const changeAlbumCollectionItemNumberModelSchema = z.object({
    "number": z.number().int().describe("Новый порядковый номер альбома"),
"albumId": z.string().uuid().describe("Идентификатор альбома")
    })